import {
    SET_ASSET,
    RESET_ASSETS,
    UNSET_ASSET,
    UPDATE_ASSET
} from '../actions/types.js';

const initialState = {
    form: []
}

export function asset(state = initialState, action = {}) {
    switch (action.type) {
        case SET_ASSET:
            const newAssets = state.form.concat(action.asset);
            return Object.assign({}, state, {form: newAssets});
        case UPDATE_ASSET:
            const withUpdates = state.form.map(a => {
                if (a.id === action.asset.id) {
                    a.name = action.asset.name;
                    a.description = action.asset.description;
                }
                return a;
            });

            return Object.assign({}, state, {form: withUpdates});
        case UNSET_ASSET:
            return Object.assign({}, state, {form: state.form.filter(a => a.name !== action.assetName)})
        case RESET_ASSETS:
            return initialState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/asset.js